import styled from '@emotion/styled'
import { IconPremium } from '../../icons/IconPremium/IconPremium'
import { BreachWallStyle } from '../../user-registration/breach/helpers/BreachWallTypes'
import { colors } from '../../__styling/settings/colors'
import { breakpoint, breakpointMax } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { themedValue } from '../../__styling/themed-value'

export const StyledMessageBannerNewBreach = styled('div')(() => ({
    position: 'relative',
    width: '100%',
    background: 'none',
    color: colors.black,
    '& div': {
        width: 'auto',
    },
}))

export const StyledMessageBannerWrapper = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    fontFamily: theme.fonts.sansSerif,
    [breakpointMax('xs')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
}))

export const StyledIconPremium = styled(IconPremium)<{
    breachStyle?: BreachWallStyle
}>(({ breachStyle }) => [
    {
        width: calcRem(30),
        height: calcRem(30),
        margin: calcRem(0, 14),
    },
    // PROMO: Digital Radio and Papers
    breachStyle === 'digital-radio-and-papers' && {
        margin: calcRem(0, 8, 0, 0),
    },
])

export const StyledMessageCTA = styled('div')<{
    isLightText?: boolean
    breachStyle?: BreachWallStyle
}>(({ theme, isLightText, breachStyle }) => [
    {
        justifySelf: 'flex-start',
        height: '100%',

        p: {
            margin: 0,
            fontSize: calcRem(16),
            color: isLightText ? colors.white : colors.black,
        },
    },
    // PROMO: Digital Radio and Papers
    breachStyle === 'digital-radio-and-papers' && {
        p: {
            fontSize: calcRem(14),
            lineHeight: calcRem(16),
        },
    },
])

export const StyleMessageCTAIconBannerGroup = styled('div')<{
    breachStyle?: BreachWallStyle
}>(({ theme, breachStyle }) => [
    {
        display: 'flex',
        width: '50%',
        [breakpointMax('xs')]: {
            width: '100%',
            justifyContent: 'flex-start',
        },
    },
    // PROMO: Digital Radio and Papers
    breachStyle === 'digital-radio-and-papers' && {
        alignItems: 'center',
    },
])

export const StyledMessageBannerGroup = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: calcRem(48),
    width: `calc(100% - ${calcRem(48)})`,
    borderColor: themedValue(theme, {
        thewest: colors.thewest.westblue,
        fallback: colors.black,
    }),
    [breakpoint('xxs')]: {
        marginLeft: calcRem(58),
    },

    [breakpoint('xs')]: {
        width: '50%',
        borderLeft: `1px solid`,
        marginLeft: 0,
        justifyContent: 'center',
    },
}))

export const StyledSubscriberMessage = styled('p')(({ theme }) => ({
    lineHeight: 1.2,
    fontWeight: 700,
    fontSize: calcRem(15),
}))

export const StyledButton = styled('button')(({ theme }) => ({
    background: 'none',
    border: 'none',
    fontFamily: theme.fonts.sansSerif,
    color: themedValue(theme, {
        thewest: colors.thewest.westblue,
        fallback: colors.black,
    }),
    lineHeight: 1.2,
    fontWeight: 700,
    fontSize: calcRem(15),
    cursor: 'pointer',
}))
